const DEFAULT_MAX_PORT = 15;

const isValidNumber = (value) => typeof value === 'number' && Number.isFinite(value);

export const expandSlotTreeSelection = (selection = [], maxPort = DEFAULT_MAX_PORT) => {
  const bySlot = new Map();

  selection.forEach((value) => {
    if (!value || !isValidNumber(value.slot)) {
      return;
    }

    const slot = value.slot;
    const ports = bySlot.get(slot) || new Set();

    if (value.port === null || value.port === undefined) {
      for (let port = 0; port <= maxPort; port += 1) {
        ports.add(port);
      }
    } else if (isValidNumber(value.port)) {
      ports.add(value.port);
    }

    bySlot.set(slot, ports);
  });

  const expanded = [];
  bySlot.forEach((ports, slot) => {
    [...ports]
      .sort((a, b) => a - b)
      .forEach((port) => {
        expanded.push({ slot, port });
      });
  });

  return expanded.sort((a, b) => {
    if (a.slot !== b.slot) {
      return a.slot - b.slot;
    }
    return a.port - b.port;
  });
};

export const buildSlotPortKeySet = (selection = []) =>
  new Set(selection.map(({ slot, port }) => `${slot}:${port}`));
